<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
	<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    
  <div class=" col-md-6 col-12 p-0">
    <div class="col-12 mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
				<h3><strong>{{msglist[$route.params.language][5]}}</strong></h3>
		</div>
    
      <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col border-left align-self-center">
                
                <div class="row px-0 mx-0">{{msglist[$route.params.language][6]}} 
                  <div class="col px-2 mx-0 mb-2 align-self-center">
                      <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.email" type="text" class="form-control">
                  </div>  
                </div>
                <div class="col px-0 mx-0 mb-2">{{msglist[$route.params.language][7]}}</div>
                
              
                <div class="col-12 text-center">
                    <button @click="getbackaccount()" class="mb-2 btn btn-primary" style="min-width: 100px;">{{msglist[$route.params.language][8]}}</button><!--送出-->
                    <router-link :to="{ name: 'entry', params: { language: $route.params.language }}">
          			        <button class="mb-2 btn btn-primary" style="min-width: 40px;">{{msglist[$route.params.language][9]}}</button><!--登入-->
          		      </router-link>
                    <router-link :to="{ name: 'register', params: { language: $route.params.language }}">
          			        <button class="mb-2 btn btn-primary" style="min-width: 40px;">{{msglist[$route.params.language][10]}}</button><!--註冊-->
          		      </router-link>
                </div>
                <div class="col mb-0" v-bind:class="alertObject" style="font-size:1.2rem; font-weight: bold"> {{message}} </div>
            </div>
         </div>
		  </div>      
  </div>  
  </div>
</template>

<script>
  //import has from 'lodash/has';
  //import Log from 'loglevel';
  //let PURL = process.env.SERVER;
  
  const mlist = {
	'en': [
        'Error, email not match',
        'Account information is sent to email',
        'Error!',
        'Space not allowed in email',
        'Empty','Forget Username & Password','E-mail','Send account information by registered E-mail.','Send','Sign in','Sign up',],
  'vi': [
        'Lỗi, Email Không Khớp',
        'Thông Tin Tài Khoản Được Gửi Tới Email',
        'Lỗi!',
        'Không được khoảng trống trong Email',
        'Trống','Quên Tài Khoản Và Mật Khẩu','E-mail','Gửi Thông Tin Tài Khoản Mà Email Đã Đăng Kí','Gửi','Đăng Nhập','Đăng Kí',],
  'ms': [
        'Error, email not match',
        'Account information is sent to email',
        'Error!',
        'Space not allowed in email',
        'Empty','Forget Username & Password','E-mail','Send account information by registered E-mail.','Send','Sign in','Sign up',],
	'tw': [
        '錯誤! 無此電郵，電郵沒登記過',
        '會員資訊已傳至電郵',
        '錯誤!',
        '電郵不可有空格字',
        '空白','忘記帳號密碼','電郵','傳送帳號資訊，限已登記過的E-mail','傳送','登入',
        '註冊',],
	'cn': [
        '错误! 无此电邮，电邮没登记过',
        '会员资讯已传至电邮',
        '错误!',
        '电邮不可有空格字',
        '空白','忘记帐号密码','电邮','传送帐号资讯，限已登记过的E-mail','传送','登录','注册',]
}

  export default {
    name: "forget",
    data: function() {
      return {
        message: "",
        msglist: mlist,
        user: {
          email: "",
          username: "",
          password: "",
          confirm: "",
          uitimezone: -12
        }
      }
    },
    computed: {
      alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
      },
    },
    methods: {

      setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
        }, timer*1000);
      },
      setMsg1: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            ////// to complete logout and show login page need this 3 items
            //this.$store.dispatch("setUser", {name: '', token: ''});
            //this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
    },    
      getbackaccount: function() {
        // this.$router.push('/home/' + this.$auth.getLang());
        //console.log("register: ", this.user.username);
        console.log("Forget account email: ", this.user);
        let router = this.$router;
        
        if (this.user.email.indexOf(" ") == -1) {   // check for space in username password email string
          let PURL = localStorage.getItem("server") || process.env.SERVER;
          this.$http.post(PURL + "/api/v1/KH/getback-account", this.user)
          .then(function(res) {
            //console.log("res: ", res);
            console.log("Success! account information send to email");
            this.message=this.msglist[this.$route.params.language][1];
            this.setMsg(this.message + this.user.username, 5);
            //setTimeout(() => {
            //  this.$router.push("login");
            //}, 5000);
          }, reason => {
            let rea=JSON.stringify(reason) ;   
            
              //Vue.message = 'error: server error when fetching: ';
              if (rea.match(/email not match/gi)) {
                  this.message=this.msglist[this.$route.params.language][0];
              } else if (rea.match(/email empty/gi)) {
                  this.message=this.msglist[this.$route.params.language][4];
              } else {
                  this.message=this.msglist[this.$route.params.language][2];
              }
              this.setMsg(this.message, 5);
          }); // reason // then(function(res)
        } else {   // if there is a space in username passwoed string
            console.log('server error: ', 'found Space in email');
            this.message=this.msglist[this.$route.params.language][3];
            this.setMsg(this.message, 5);}  
         
    
      } // register function
    } // method:
  }  // export default
</script>

<style>

</style>



// WEBPACK FOOTER //
// Forget.vue?c7ea3212